import { render, staticRenderFns } from "./ZaitonTransferContractDesignKurdish.vue?vue&type=template&id=30a0e0e8&scoped=true&"
import script from "./ZaitonTransferContractDesignKurdish.vue?vue&type=script&lang=js&"
export * from "./ZaitonTransferContractDesignKurdish.vue?vue&type=script&lang=js&"
import style0 from "./ZaitonTransferContractDesignKurdish.vue?vue&type=style&index=0&id=30a0e0e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a0e0e8",
  null
  
)

export default component.exports